/* eslint-disable react/no-array-index-key */
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { TemplateApiItem } from "../types/api-types";
import ExportCsvButton from "../../shared/export/export-csv-button";
import type { CsvColumn } from "../../shared/export/csv-export";

const exportColumns: CsvColumn<TemplateApiItem>[] = [
  { header: "Endpoint", value: (api) => api.endpoint },
];

interface TemplateApisTableProps {
  templateApis: TemplateApiItem[];
  onDelete: (api: TemplateApiItem) => void;
  isLoading?: boolean;
}

const TemplateApisTable = ({
  templateApis,
  onDelete,
  isLoading = false,
}: TemplateApisTableProps) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (templateApis.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      sx={{
        maxHeight: 300,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              "& .MuiTableCell-root": {
                fontWeight: 600,
                color: "primary.main",
                bgcolor: "grey.50",
              },
            }}
          >
            <TableCell>Endpoint</TableCell>
            <TableCell align="right" sx={{ width: 100 }}>
              <ExportCsvButton
                rows={templateApis}
                columns={exportColumns}
                fileName="template-apis"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {templateApis.map((api, index) => (
            <TableRow
              key={`api-${index}`}
              sx={{
                "&:hover": {
                  bgcolor: "grey.50",
                },
              }}
            >
              <TableCell>{api.endpoint}</TableCell>
              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={() => onDelete(api)}
                  sx={{
                    color: "grey.600",
                    transition: "all 0.2s",
                    "&:hover": {
                      color: "error.main",
                      bgcolor: "error.50",
                      transform: "scale(1.1)",
                    },
                  }}
                  aria-label="Delete API"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TemplateApisTable;
